/* eslint-disable no-console */
import axios from 'axios'

import getLocaleParam from 'Pods/Shared/Utils/getLocaleParam'

const buildLocaleParams = (localeOverride) => {
  const locale = localeOverride || getLocaleParam()
  return locale ? { locale } : {}
}

export const featuredDesignerService = {
  async getFeaturedDesigner(locale) {
    try {
      const response = await axios.get('/api/internal/featured_designers', {
        params: buildLocaleParams(locale),
      })
      return response?.data
    } catch (error) {
      console.error('Error fetching featured designer:', error)
      window.Sentry.captureException(error, {
        tags: { context: 'featured_designer_service' },
      })
      throw error
    }
  },

  async getFeaturedDesigners(sampleSize = 3, options = {}) {
    try {
      const response = await axios.get('/api/internal/featured_designers', {
        params: {
          sample_size: sampleSize,
          ...buildLocaleParams(options.locale),
        },
      })
      return response?.data
    } catch (error) {
      console.error('Error fetching featured designers:', error)
      window.Sentry.captureException(error, {
        tags: { context: 'featured_designer_service' },
        extra: { sampleSize, locale: options.locale },
      })
      throw error
    }
  },
}
